import MalwareBlockingIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/malware-block-icon.svg'
import WebFilteringIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/web-filtering.svg'
import ServiceFilteringIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/service-filter-fixed.svg'
import CustomFilteringIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/custom-filtering.svg'
import ContentFilteringIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/content-filtering.svg'
import DnsFilteringIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/dns-filtering.svg'
import ModernProtocolsIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/modern-protocols.svg'
import AnalyticsIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/analytics.svg'
import DataStreamingIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/data-streaming.svg'
import TrafficRedirectionIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/traffic-redirection.svg'
import MultiTenancyIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/multi-tenancy.svg'
import AdminLogsIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/admin-logs.svg'
import IntegrationsIcon from 'images/organization/homepage/headerNavMenu/featuresIcons/integrations.svg'
import BrowseFasterIcon from 'images/homePage/features/browse-faster.svg'
import ImproveProductivityIcon from 'images/homePage/features/improve-productivity.svg'
import SwitchLocationIcon from 'images/homePage/features/switch-location.svg'
import ProtectKidsIcon from 'images/homePage/features/protect-kids.svg'
import CustomizeProfilesIcon from 'images/homePage/features/customize-profiles.svg'
import AvailableServicesIcon from 'images/homePage/features/available-services.svg'

export const orgFeatures = [
  {
    header: 'Malware Blocking',
    icon: MalwareBlockingIcon,
    description: 'Reduce the chance of a compromise.',
    href: '/features/malware-blocking',
  },
  {
    header: 'Modern Protocols',
    icon: ModernProtocolsIcon,
    description: 'Use secure and encrypted DNS protocols.',
    href: '/features/modern-protocols',
  },
  {
    header: 'Web Filtering',
    icon: WebFilteringIcon,
    description: 'Block access to unwanted content.',
    href: '/features/web-filtering',
  },
  {
    header: 'Service Filtering',
    icon: ServiceFilteringIcon,
    description: 'Block individual web services and apps.',
    href: '/features/service-filtering',
  },

  {
    header: 'Custom Filtering',
    icon: CustomFilteringIcon,
    description: 'Control DNS resolution of any domain name.',
    href: '/features/custom-filtering',
  },
  {
    header: 'Content Filtering',
    icon: ContentFilteringIcon,
    description: 'Block harmful sites. Boost security in minutes.',
    href: '/features/content-filtering',
  },
  {
    header: 'DNS Filtering',
    icon: DnsFilteringIcon,
    description: 'Protect users from malware with DNS filtering.',
    href: '/features/dns-filtering',
  },
  {
    header: 'Multi-Tenancy',
    icon: MultiTenancyIcon,
    description: 'Group assets into sub-organizations.',
    href: '/features/multi-tenancy',
  },
  {
    header: 'Data Streaming (SIEM)',
    icon: DataStreamingIcon,
    description: 'Stream raw query logs into your SIEM.',
    href: '/features/data-streaming-siem',
  },
  {
    header: 'Analytics',
    icon: AnalyticsIcon,
    description: 'Gain insights with comprehensive analytics.',
    href: '/features/analytics',
  },
  {
    header: 'Admin Logs',
    icon: AdminLogsIcon,
    description: 'Keep a paper trail of all admin actions.',
    href: '/features/admin-logs',
  },
  {
    header: 'Traffic Redirection',
    icon: TrafficRedirectionIcon,
    description: 'Redirect traffic through network of proxies.',
    href: '/features/traffic-redirection',
  },
  {
    header: 'Integrations',
    icon: IntegrationsIcon,
    description: 'Discover compatible tools and platforms.',
    href: '/features/integrations',
  },
]

export const personalFeatures = [
  {
    header: 'Browse Faster',
    icon: BrowseFasterIcon,
    href: '/browse-faster',
  },
  {
    header: 'Improve Productivity',
    icon: ImproveProductivityIcon,
    href: '/improve-productivity',
  },
  {
    header: 'Switch Your Location',
    icon: SwitchLocationIcon,
    href: '/teleport',
  },
  {
    header: 'Protect Your Kids',
    icon: ProtectKidsIcon,
    href: '/parental-controls',
  },
  {
    header: 'Customize Multiple Profiles',
    icon: CustomizeProfilesIcon,
    href: '/multi-device',
  },
  {
    header: 'Available Services',
    icon: AvailableServicesIcon,
    href: '/available-services',
  },
]
